<template>
  <li class="c-playlist__item c-playlist__item--hidden" v-if="!voting">
    <div class="o-playlist">
      <div class="o-playlist__position">1</div>
      <div class="o-playlist__image"></div>
      <div class="o-playlist__content">
        <h3 class="o-playlist__title">Obfuscated track name</h3>
        <p class="o-playlist__artist">Obfuscated artist name</p>
      </div>
      <div class="o-playlist__actions">
        <PreviewTrack url="" />
        <Like selectorCode="" />
      </div>
    </div>
    <div class="o-playlist">
      <div class="o-playlist__position">2</div>
      <div class="o-playlist__image"></div>
      <div class="o-playlist__content">
        <h3 class="o-playlist__title">Short</h3>
        <p class="o-playlist__artist">SOME AWESOME BAND</p>
      </div>
      <div class="o-playlist__actions">
        <PreviewTrack url="" />
        <Like selectorCode="" />
      </div>
    </div>
    <div class="o-playlist__message">
      <SvgIcon icon="lock" class="o-playlist__icon o-icon--large" aria-hidden="true" />
      <p>De top {{count}} houden we nog even geheim</p>
    </div>
  </li>

  <li class="c-playlist__item c-playlist__item--hidden" v-else>
    <div class="o-playlist">
      <div class="o-playlist__position">1</div>
      <div class="o-playlist__image"></div>
      <div class="o-playlist__content">
        <h3 class="o-playlist__title">track.title</h3>
        <p class="o-playlist__artist">track.artist</p>
      </div>
      <div class="o-playlist__actions">
        <PreviewTrack :url="false" />
        <Like :selectorCode="111" />
      </div>
    </div>
    <div class="o-playlist__message">
      <a href="#" class="c-button c-button--large">Stem op de top 10</a>
    </div>
  </li>
</template>

<script>
import Like from '../like/Like';
import PreviewTrack from '../tracks/PreviewTrack';

export default {
  name: "HiddenTracks",
  props: ["count"],
  data() {
    return {
      voting: false
    }
  },
  components: {
    Like, PreviewTrack
  }
};
</script>

<style>
</style>